module.exports = __webpack_public_path__ + "img/CV.Drainage.Drainage_trench.PVC_pipe.a7aaf0f8.png";